import { Icon } from '@mdvip/shared/components/blocks/Icon';
import { Alert, AlertDescription, AlertTitle } from '@mdvip/shared/components/ui/alert';
import { Button } from '@mdvip/shared/components/ui/button';
import { useErrorTranslation } from '@mdvip/shared/hooks/useErrorTranslation';
import { extractGqlErrorCode } from '@mdvip/shared/lib/gqlErrors';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { TransactionsTable } from '@/components/payments/transactions/TransactionsTable';
import { usePaymentTransactions } from '@/hooks/payments/transactions/usePaymentTransactions';

const ROWS_PER_PAGE = 10;

export function PastTransactionsPage() {
  const { t } = useTranslation('members');
  const tError = useErrorTranslation();
  const [page, setPage] = useState(1);
  const { data, isPending, isError, error, refetch } = usePaymentTransactions({
    offset: (page - 1) * ROWS_PER_PAGE,
    limit: ROWS_PER_PAGE,
  });

  const state = isError ? 'error' : isPending ? 'loading' : 'loaded';

  return (
    <TransactionsTable
      transactions={data?.edges ?? []}
      state={state}
      paginate
      page={page}
      perPage={ROWS_PER_PAGE}
      totalCount={data?.totalCount ?? 0}
      onPageChange={setPage}
      title={t('payments.pages.pastTransactions.sectionTitle')}
      description={t('payments.transactions.disclaimer')}
      emptyMessage={t('payments.pages.pastTransactions.emptyState')}
      errorContent={
        <Alert variant="destructive">
          <Icon name="alertCircle" />
          <AlertTitle>{t('payments.pages.pastTransactions.errorTitle')}</AlertTitle>
          <AlertDescription>
            <p>{tError(extractGqlErrorCode(error))}</p>
            <Button variant="outline" size="sm" className="mt-3" onClick={() => refetch()}>
              {t('config.retry')}
            </Button>
          </AlertDescription>
        </Alert>
      }
    />
  );
}
